import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { EditDialogData } from './interfaces';
import { TranslateModule } from '@ngx-translate/core';
import { PipesModule } from '@shared/pipes/pipes.module';
import {
  DvDynamicFormModule,
  DvDynamicFormUtils,
  DvFormUtils,
  FormOf,
} from '@devinco/ui/legacy';
import { FormGroup } from '@angular/forms';
import { DvAlertBannerComponent } from '@devinco/ui/dds/alert-banner';
import {
  DvButtonComponent,
  DvDialogContent,
  DvDialogContentComponent,
} from '@devinco/ui/dds';

@Component({
  selector: 'app-edit-dialog',
  imports: [
    DvDialogContentComponent,
    DvAlertBannerComponent,
    DvDynamicFormModule,
    DvButtonComponent,
    TranslateModule,
    PipesModule,
  ],
  changeDetection: ChangeDetectionStrategy.Eager,
  templateUrl: './edit-dialog.component.html',
})
export class EditDialogComponent<T>
  extends DvDialogContent<EditDialogData<T>, EditDialogComponent<T>>
  implements OnInit
{
  formGroup: FormGroup<FormOf<T>>;
  constructor() {
    super();
  }

  ngOnInit(): void {
    this.formGroup = DvFormUtils.createFormGroup(this.data.elements);

    if (this.data.entityData) {
      DvDynamicFormUtils.setFirstData(
        this.data.elements || [],
        this.formGroup,
        this.data.entityData
      );
    }

    this.data.afterReadyFn?.(this.formGroup);
  }

  performSave(): void {
    this.dialogRef.onConfirm(this.formGroup.value);
  }
}
